export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
vm(require("avatar-components/lang/en.lyaml"));
vm(require("usage-based-billing-components-lib/lang/en.lyaml"));
vm(require("./features/agent-status/en.lyaml"));
vm(require("./features/reassignment/en.lyaml"));
vm(require("./features/routing-rules/en.lyaml"));
vm(require("./features/teams/en.lyaml"));
vm(require("./features/users-and-teams/en.lyaml"));
vm(require("./features/prompts/en.lyaml"));
at({ "en": { "routing-ui": { "shared": { "alerts": { "RETRY": { "message_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "There was a network connection issue.", createElement( options, "br", null ), " Please check your connection and ", createElement( options, "Link", props, "try again" ), "." ); }, "button": "Try again" } } } } } });
};